import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from 'react-router-dom';

import Login from './pages/Login';
import AdminLayout from './layouts/AdminLayout';
import OperatorPanel from './pages/OperatorPanel';
import PlatformLayout from './layouts/PlatformLayout';
import CustomerPortal from './pages/CustomerPortal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Badminton from './pages/Badminton';
import FuelStory from './pages/FuelStory';

function AppWrapper() {
  const navigate = useNavigate();

  const readRole = () => {
    const raw = localStorage.getItem('role');
    if (!raw) return '';
    try {
      return String(JSON.parse(raw)).trim().toLowerCase();
    } catch {
      return String(raw).trim().toLowerCase();
    }
  };

  const role = readRole();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  const isAdminOrManager = role === 'admin' || role === 'manager';
  const isOperator = role === 'operator' || role === 'manager';
  const isPlatformUser = role === 'super_admin' || role === 'support_admin';
  const isCustomer = role === 'customer';

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/badminton" element={<Badminton />} />
      <Route path="/fuel-story" element={<FuelStory />} />

      <Route
        path="/platform/*"
        element={
          isPlatformUser ? (
            <PlatformLayout onLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/admin/*"
        element={
          isAdminOrManager ? (
            <AdminLayout onLogout={handleLogout} />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />

      <Route
        path="/operator"
        element={
          isOperator ? <OperatorPanel onLogout={handleLogout} /> : <Navigate to="/" replace />
        }
      />

      <Route
        path="/customer/*"
        element={
          isCustomer ? <CustomerPortal /> : <Navigate to="/" replace />
        }
      />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
